module.exports = __webpack_public_path__ + "img/diary-difficulty.42919f46.svg";